<style src="./QuotesMapContextFilter.scss" lang="scss"></style>
<template>
  <section class="quotesmap-context-filter">
    <form @submit.prevent="sendFilter" class="rowsection">
      <span class="filtertitle">Filtrar por estado da cotação:</span>
      <div class="filters">
        <label class="option">
          <input
            type="checkbox"
            value="avaliableQuotation"
            v-model="filters.filterValue"
            @change="sendFilter">
          <span class="avaliable">Cotação Disponível</span>
        </label>
        <label class="option">
          <input
            type="checkbox"
            value="waitingResponseQuotation"
            v-model="filters.filterValue"
            @change="sendFilter">
          <span class="waiting">Aguardando Fornecedor</span>
        </label>
        <label class="option">
          <input
            type="checkbox"
            value="rejectedQuotation"
            v-model="filters.filterValue"
            @change="sendFilter">
          <span class="rejected">Itens rejeitados</span>
        </label>
        <label class="option">
          <input
            type="checkbox"
            value="noquoteQuotation"
            v-model="filters.filterValue"
            @change="sendFilter">
          <span class="noquote">Não Cotados pelo fornecedor</span>
        </label>
        <label class="option">
          <input
            type="checkbox"
            value="noSendedQuotation"
            v-model="filters.filterValue"
            @change="sendFilter">
          <span class="noquote">Sem cotação enviada</span>
        </label>
      </div>
    </form>

     <div class="rowsection mt">
      <span class="filtertitle">Escolha automática</span>
      <div class="autochoices">
        <span class="title">Cotar Associado</span>
        <span class="description">
          Escolhe todos os items que tenham uma associação e não tenham nenhuma cotação aberta ou pendente.<br />
          Se houver apenas cotação marcada como "não cota" será escolhido o associado.
        </span>
        <span class="command">
          <context-select-associated />
        </span>
      </div>
      <div class="autochoices">
        <span class="title">Cotar Fornecedor</span>
        <span class="description">
          Escolhe automáticamente todos os itens que tenham 1 cotação com fornecedor respondida
          Se houver cotação pendente ou mais de uma cotação respondida, não será feita a escolha automática
        </span>
        <span class="command">
          <context-select-quotes />
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import ContextSelectAssociated from '../context-select-associated/ContextSelectAssociated'
import ContextSelectQuotes from '../context-select-quotes/ContextSelectQuotes'

export default {
  name: 'QuotesMapContextFilter',
  components: {
    ContextSelectAssociated,
    ContextSelectQuotes
  },
  props: {
    columnId: {
      default: null
    },
    activeOptions: {
      default: 0
    }
  },
  data: () => ({
    filters: {
      filterType: 'KEY',
      filterValue: []
    }
  }),
  mounted () {
    this.filters.filterValue = this.activeOptions
  },
  // watch: {
  //   'filters.filterValue' () {
  //     this.sendFilter()
  //   }
  // },
  methods: {
    sendFilter () {
      const filter = {
        columnId: this.columnId,
        filterType: this.filters.filterType,
        filterValue: this.filters.filterValue
      }
      this.$emit('filter-value', filter)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-quotesmap-filter/QuotesMapContextFilter.vue